module.exports = __webpack_public_path__ + "static/media/touch_icon.41016aac.svg";